import { Component, OnInit, ViewChild, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import {
  PatientsRunDateComponent, BaseComponent, QueryService, SearchService, TitleService, FilterService, ReportKeys,
  TestResult_PatientsByRunDateRow, DateGroupType
} from '../../core';
import { TranslateService } from '@ngx-translate/core';
import { NgxMatToastService } from 'ngx-mat-toast';
import { MatRadioChange } from '@angular/material/radio';
import { GoogleAnalyticsService } from '../../core/services/google-analytics.service';
import { translate } from 'src/app/core/utils/translateServiceHelper';

@Component({
  selector: 'app-report-patient-run-date',
  templateUrl: './report-patient-run-date.component.html',
  styleUrls: ['./report-patient-run-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ReportPatientRunDateComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('chart', { static: true }) private patientsRunDate: PatientsRunDateComponent;

  public selectedValue: DateGroupType;
  public DateGroupType = DateGroupType;

  constructor(private queryService: QueryService,
    private searchService: SearchService,
    private titleService: TitleService,
    private filterService: FilterService,
    private toastr: NgxMatToastService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private translate: TranslateService) {
    super();

    this.selectedValue = DateGroupType.Month;

  }


  ngOnInit(): void {

    this.subscription.add(this.queryService.filtersApplied.subscribe((filtersApplied: boolean) => {
      console.debug(`Filters applied: ${filtersApplied}`);
    }));

    this.subscription.add(this.queryService.searchRequested.subscribe(() => {
      this.onSearch();
    }));

    this.onSearch();

    this.titleService.updateTitleTranslateKey('ReportMenu.PatientsByRunDate');
  }

  onChange(changeValue: MatRadioChange): void {
    this.selectedValue = changeValue.value as DateGroupType;
    console.debug('test');
    this.onSearch();
  }

  onSearch(): void {
    if (this.filterService.isReportEnabled(ReportKeys.PatientsByRunDate)) {
      this.googleAnalyticsService.logWithLabels('View Report', 'Report', 'View Patient By Run Date Report', 'filters', this.queryService.getCurrentQuery(true), 'groupType', this.googleAnalyticsService.getDateGroupType(this.selectedValue));
      this.subscription.add(this.searchService.getReportPatientsByRunDate(
        {
          query: this.queryService.getCurrentQuery(true),
          dateGroupType: this.selectedValue
        }).subscribe(
        (result: TestResult_PatientsByRunDateRow[]) => {
          if (!result || result.length === 0) {
            const title = translate(this.translate, 'ReportMenu.NoDataToShow');
            this.toastr.info(title);
            return;
          }

          this.patientsRunDate.setData(result);
        }));
    } else {
      const message = translate(this.translate, 'ReportMenu.RequirePatient');
      const title = translate(this.translate, 'ReportMenu.ReportLoadError');
      this.toastr.error(message, title);
    }
  }

  ngOnDestroyInternal(): void {
    // Required by base component
  }

  savePDF(): void {
    this.patientsRunDate.saveAsPdf();
  }

  saveImage(): void {
    this.patientsRunDate.saveAsImage();
  }

}
